const base_url ="https://medzeb-happen.eu/pos-v2"
//const base_url ="http://pos.localhost"

var auth_headers = new Headers();
        auth_headers.append("Authorization", 'Basic ' + btoa('happen:H4pp3N!'));  
        auth_headers.append("Content-Type", "application/json");  
        
export { base_url, auth_headers}

